// src/components/opportunity/OpportunitySignedConfirmModal.tsx

export type OpportunitySignedConfirmModalProps = {
  open: boolean;
  busy: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export function OpportunitySignedConfirmModal(props: OpportunitySignedConfirmModalProps) {
  const { open, busy, onConfirm, onCancel } = props;
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/40 px-4">
      <div
        className="w-full max-w-md rounded-2xl bg-white p-5 shadow-xl dark:bg-zinc-900"
        role="dialog"
        aria-labelledby="opp-signed-confirm-title"
      >
        <h3
          id="opp-signed-confirm-title"
          className="text-lg font-bold text-gray-900 dark:text-zinc-100"
        >
          Send to service intake?
        </h3>
        <p className="mt-2 text-sm text-gray-600 dark:text-zinc-400">
          Make sure this opportunity is ready to be processed in service intake. Setting status to
          Signed will queue service work when a matching offering exists.
        </p>
        <div className="mt-4 flex flex-wrap items-center justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            disabled={busy}
            className="px-3 py-1.5 rounded-lg border border-gray-300 text-sm text-gray-700 hover:bg-gray-50 dark:border-zinc-700 dark:text-zinc-200 dark:hover:bg-zinc-800 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={busy}
            className="px-3 py-1.5 rounded-lg bg-indigo-600 text-white text-sm hover:bg-indigo-700 disabled:opacity-50"
          >
            {busy ? "Saving…" : "Mark Signed"}
          </button>
        </div>
      </div>
    </div>
  );
}
